/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TokenObject } from './tokenObject';


export interface LootboxChanceContent { 
    type?: LootboxChanceContent.TypeEnum;
    object?: TokenObject;
}
export namespace LootboxChanceContent {
    export type TypeEnum = 'token';
    export const TypeEnum = {
        Token: 'token' as TypeEnum
    };
}


